import React from "react";
import "./pageNotFound.css";
import { useNavigate } from "react-router-dom";
import string from "../../utils/strings";
import Image from "../../Assets/image";

const PageNotFound = () => {
  const nav = useNavigate();
  return (
    <div className="pageNotFound">
      <img src={Image.ErrorBg} alt="error" />
      <main className="error-page">
        <div className="container">
          <div className="eyes">
            <div className="eye">
              <div className="eye__pupil eye__pupil--left"></div>
            </div>
            <div className="eye">
              <div className="eye__pupil eye__pupil--right"></div>
            </div>
          </div>

          <div className="error-page__heading">
            <h1 className="error-page__heading-title">Looks like you're lost</h1>
            <h1 className="error-page__heading-description">
              We looked everywhere for this URL page. <br />
              Are you sure the website URL is correct? <br />
              Get in touch with the site owner.
            </h1>
          </div>
          <p className="error-page__button" onClick={() => nav(string.navigation.department)}>
            Back to home
          </p>
        </div>
      </main>
    </div>
  );
};

export default PageNotFound;
